import React, { useState, useEffect } from "react";
import CustomTable from "../../../components/table/table";
import "./view.css";
import ConfirmDialog from "../../../components/actionDialogs/confirmDialog";
import {
  admin_challenge_opportunity_delete,
  get_challenge_opportunity_list,
} from "../admin.api";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import jwtDecode from "jwt-decode";

export default function View(props) {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [view, setView] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedOpportunity, setSelectedOpportunity] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const [openAction, setOpenAction] = useState(false);
  const [activeData, setActiveData] = useState({});
  const assetBaseUrl = (process.env.REACT_APP_BASE_URL || "").replace(
    /\/api\/?$/,
    ""
  );

  const onSearch = () => {
    applyFilters();
  };

  const applyFilters = () => {
    let filtered = [...data];
    
    // Filter by opportunity
    if (selectedOpportunity) {
      filtered = filtered.filter(item => 
        item.opportunity === selectedOpportunity
      );
    }
    
    // Filter by status
    if (selectedStatus !== "") {
      filtered = filtered.filter(item => 
        item.status_code === Number(selectedStatus)
      );
    }
    
    // Filter by title (search)
    if (searchTerm) {
      filtered = filtered.filter(item => 
        item.title && item.title.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    
    setFilteredData(filtered);
  };

  const getUniqueOpportunities = () => {
    const opportunities = [...new Set(data.map(item => item.opportunity).filter(Boolean))];
    return opportunities.sort();
  };
  const handleChallengeOpportunityList = async () => {
    setIsActive(true);
    try {
      const res = await get_challenge_opportunity_list();
      const tdata = Array.isArray(res)
        ? res.map((item, index) => ({
            ...item,
            slno: index + 1,
            opportunity:
              item?.market_analysis_opportunity?.opportunity ??
              item?.market_analysis_opportunity_name ??
              item?.opportunity ??
              "",
            status_code:
              String(item?.status).toLowerCase() === "pending" ||
              String(item?.status) === "0"
                ? 0
                : String(item?.status).toLowerCase() === "approved" ||
                  String(item?.status) === "1"
                ? 1
                : String(item?.status).toLowerCase() === "rejected" ||
                  String(item?.status).toLowerCase() === "reject" ||
                  String(item?.status) === "2"
                ? 2
                : item?.status,
            image:
              item?.image && assetBaseUrl
                ? `${assetBaseUrl}/${String(item.image).replace(/^\//, "")}`  
                : item?.image || "",
            brochure:
              item?.brochure && assetBaseUrl
                ? `${assetBaseUrl}/${String(item.brochure).replace(/^\//, "")}`
                : item?.brochure || "",
          }))
        : [];

      setData(tdata);
    } catch (error) {
      setData([]);
      setSnackMessage(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to fetch challenge opportunity list"
      );
      setIsSnackError(true);
      setSnackOpen(true);
    } finally {
      setIsActive(false);
    }
  };

  useEffect(() => {
    handleChallengeOpportunityList();
  }, []);

  useEffect(() => {
    setFilteredData(data);
  }, [data]);

  useEffect(() => {
    applyFilters();
  }, [searchTerm, selectedOpportunity, selectedStatus, data]);

  useEffect(() => {
    return () => {
      setData([]);
      setFilteredData([]);
    };
  }, []);

  const handleEdit = (row) => {
    props.history.push({
      pathname: `/challenges-edit/${row.id}`,
      state: { row },
    });
  };

  const handleAddNew = () => {
    let path = "/challenges-add";
    props.history.push(path);
  };

  const handleView = (data) => {
    props.history.push({
      pathname: `/challenges-view/${data.id}`,
      state: { row: data },
    });
  };

  const handleDelete = (row) => {
    setActiveData(row);
    setOpenAction(true);
  };

  const handleCancelDelete = () => {
    setOpenAction(false);
  };

  const handleDeleteConfirm = (row) => {
    setOpenAction(false);
    setIsActive(true);
    admin_challenge_opportunity_delete(row.id)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
      })
      .catch((error) => {
        setSnackMessage(
          error?.response?.data?.message ||
            error?.message ||
            "Failed to delete"
        );
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      handleChallengeOpportunityList();
    }
  };

  return (
    <div>
      <Loader open={isActive} />
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <div className="view-container">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h6 className="mb-0">
            <b>Challenges</b>
          </h6>
        </div>
        <hr />
        
        {/* Controls Row - Add New on left, Filters on right */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          {/* Add New Button - Only for adminType === 1 */}
          {adminType === 1 && (
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={(e) => handleAddNew(e)}
            >
              Add New
            </button>
          )}
          
          {/* Filter Section - Right Side */}
          <div className="d-flex gap-2">
            <select 
              className="form-select"
              style={{ width: '200px', paddingTop: '4px', paddingBottom: '4px', fontSize: '12px' }}
              value={selectedOpportunity}
              onChange={(e) => setSelectedOpportunity(e.target.value)}
            >
              <option value="">Select Opportunity</option>
              {getUniqueOpportunities().map((opp, index) => (
                <option key={index} value={opp}>{opp}</option>
              ))}
            </select>
            <select 
              className="form-select"
              style={{ width: '150px', paddingTop: '4px', paddingBottom: '4px', fontSize: '12px' }}
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
            >
              <option value="">Select Status</option>
              <option value="0">Pending</option>
              <option value="1">Approved</option>
              <option value="2">Rejected</option>
            </select>
            <input
              type="text"
              className="form-control"
              style={{ width: '200px', paddingTop: '4px', paddingBottom: '4px', fontSize: '12px' }}
              placeholder="Search by title..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <button
              type="button"
              className="btn btn-secondary btn-sm"
              onClick={() => {
                setSearchTerm("");
                setSelectedOpportunity("");
                setSelectedStatus("");
              }}
            >
              Clear Filters
            </button>
          </div>
        </div>

        {/* --------------admin----- */}
        {adminType === 1 && (
          <>
            <CustomTable
              {...props}
              columns={[
                { title: "Sl No", field: "slno" },
                { title: "Opportunity", field: "opportunity" },
                { title: "Title", field: "title" },
                { title: "Description", field: "description" },
                { title: "Due Date", field: "due_date" },
                // { title: "Site URL", field: "site_url" },
                { title: "Status", field: "status_code", type: "mouStatus" },
                // { title: "Image", field: "image", type: "imageFull" },
              ]}
              data={filteredData}
              actions={[
                { type: "view", handleClick: handleView },
                { type: "edit", handleClick: handleEdit },
              ]}
            />
          </>
        )}
        {/* ----------------- */}
        {/* --------------admin----- */}
        {adminType === 2 && (
          <>
            <CustomTable
              {...props}
              columns={[
                { title: "Sl No", field: "slno" },
                { title: "Opportunity", field: "opportunity" },
                { title: "Title", field: "title" },
                { title: "Description", field: "description" },
                { title: "Due Date", field: "due_date" },
                // { title: "Site URL", field: "site_url" },
                { title: "Status", field: "status_code", type: "mouStatus" },
                // { title: "Image", field: "image", type: "imageFull" },  
              ]}
              data={filteredData}
              actions={[
                { type: "view", handleClick: handleView },
                { type: "delete", handleClick: handleDelete },
              ]}
            />
          </>
        )}
        {adminType === 23 && (
          <>
            <CustomTable
              {...props}
              columns={[
                { title: "Sl No", field: "slno" },
                { title: "Opportunity", field: "opportunity" },
                { title: "Title", field: "title" },
                { title: "Description", field: "description" },
                { title: "Due Date", field: "due_date" },
                { title: "Site URL", field: "site_url" },
                { title: "Status", field: "status_code", type: "mouStatus" },
                { title: "Image", field: "image", type: "imageFull" },
              ]}
              data={filteredData}
              actions={[
                { type: "view", handleClick: handleView },
              ]}
            />
          </>
        )}
      </div>
      {openAction && (
        <ConfirmDialog
          open={openAction}
          title="Delete Challenge ?"
          data={activeData}
          message="Are you sure to Delete this Challenge?"
          secondary_action="Cancel"
          primary_action="Delete"
          handleClose={handleCancelDelete}
          handleConfirm={handleDeleteConfirm}
        />
      )}
    </div>
  );
}
